/* src/app/features/contratacao/limite-contratacao/limite-contratacao-pesquisa.component.scss */
.moeda {
  text-align: right;
}
.titulo-moeda {
  text-align: right;
}
.letra-miuda {
  font-size: 12px;
  font-style: italic;
}
.texto-destaque {
  font-weight: bolder;
}
.fundo-destaque {
  background-color: lightyellow;
}
/*# sourceMappingURL=limite-contratacao-pesquisa.component.css.map */
